/**
 * 路由
 */
import Login from '../modules/personal/login/index'
import Calendar from '../modules/dataReport/calendar/index'

export default {
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/index',
      name: 'Index',
      component(resolve) {
        import('../modules/Index').then(resolve)
      },
      meta: {
        title: '开发首页'
      }
    },
    // {
    //   path: '/veri',
    //   name: 'Veri',
    //   component(resolve) {
    //     import('../modules/veri/Index').then(resolve)
    //   },
    //   meta: {
    //     title: '登录页'
    //   }
    // },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '中升二手车业务数据-登录'
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: {
        title: '中升二手车业务数据-日历'
      }
    },
    {
      path: '/reportDetail',
      name: 'reportDetail',
      component(resolve) {
        import('../modules/dataReport/report-detail/index').then(resolve)
      },
      meta: {
        title: '中升二手车业务数据-详情'
      }
    },
    {
      path: '/editReport',
      name: 'editReport',
      component(resolve) {
        import('../modules/dataReport/edit-report/index').then(resolve)
      },
      meta: {
        title: '中升二手车业务数据-编辑'
      }
    },
    {
      path: '/success',
      name: 'success',
      component(resolve) {
        import('../modules/dataReport/success/index').then(resolve)
      },
      meta: {
        title: '提交成功'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/config.js